import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=639b34d0&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=639b34d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b34d0",
  null
  
)

export default component.exports